import formAPIFollowups from "./followup";

var formattedOutput = null;

const formapimodalfollowups = (data) => {
  // Apply formAPIModel to each item in the data array
  formattedOutput = data.map(item => formAPIFollowups(item));


  return formattedOutput
};

export default formapimodalfollowups